var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExpand = function SvgExpand(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 14,
    fill: "none",
    viewBox: "0 0 19 14",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M12 11.5h4v-4h-1v3h-3zm-9-5h1v-3h3v-1H3zM2.115 14q-.69 0-1.153-.463A1.57 1.57 0 0 1 .5 12.385V1.616Q.5.926.963.462A1.57 1.57 0 0 1 2.116 0h14.768q.69 0 1.154.463.462.462.462 1.153v10.768q0 .69-.462 1.153a1.57 1.57 0 0 1-1.154.463zm0-1h14.77a.6.6 0 0 0 .423-.192.6.6 0 0 0 .192-.424V1.616a.6.6 0 0 0-.192-.424.6.6 0 0 0-.424-.192H2.116a.6.6 0 0 0-.424.192.6.6 0 0 0-.192.424v10.768q0 .232.192.424.193.192.424.192"
  })));
};
export default SvgExpand;